import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mathTrunc',
    standalone: false
})
export class MathTruncPipe implements PipeTransform {
    transform(value: number|null, truncateAboveNumbers: number = null): number|null {
      if (typeof value !== 'number') {
        return value;
      }

      return value > truncateAboveNumbers ? Math.trunc(value) : value
    }
}
